"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.boilTime = exports.use = void 0;
const use = (timing = {}) => ({
    add_to_boil: timing.use === 'add_to_boil',
    add_to_mash: !timing.use || timing.use === 'add_to_mash',
});
exports.use = use;
const boilTime = (timing = {}) => timing.use === 'add_to_boil' ? timing.time.value : 0;
exports.boilTime = boilTime;
//# sourceMappingURL=timing.js.map